import React, { useEffect } from 'react'
import MenuIcon from '@mui/icons-material/Menu';
import axios from 'axios';
import { useState } from 'react';
import dayjs from 'dayjs';
import { ConfigProvider, Pagination } from "antd";
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';
import { usePapaParse } from 'react-papaparse';
import { useCSVDownloader } from 'react-papaparse';
import { Flex, Progress } from "antd";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CustomSpinner from '../components/CustomSpinner';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
function Consents({ serverURL, user, setUser, setShowSideOverlay, socket, onlineUsers }) {

    const [currentPageNumber, setCurrentPageNumber] = useState(1)
    const [globleSearchValues, setGlobleSearchValues] = useState([])
    const [loadingEntries, setLoadingEntries] = useState(true);
    const [entriesLimit, setEntriesLimit] = useState(100)
    const [skipEntries, setSkipEntries] = useState(0)

    const [filterState, setFilterState] = useState(false)
    const [searchFilters, setSearchFilters] = useState([]);

    const [serviceTypes, setServiceTypes] = useState([]);
    const [serviceProviders, setServiceProviders] = useState([]);

    const [showTableFormOpted, setShowTableFormOpted] = useState(false)
    const [showTableFormOffered, setShowTableFormOffered] = useState(false)
    const [selectedConsent, setSelectedConsent] = useState(null)

    const [totalEntriesCount, setTotalEntriesCount] = useState(0)

    const allServiceTypes = [
        { value: "Education Loan", label: "Education Loan" },
        { value: "Block Account", label: "Block Account" },
        { value: "Forex", label: "Forex" },
        { value: "Insurance", label: "Insurance" },
        { value: "other", label: "Other" }
    ];
    const allServiceProviders = [
        { value: "gyandhan", label: "gyandhan" },
        { value: "tata", label: "tata" },
        { value: "credilla", label: "credilla" },
        { value: "coracle", label: "coracle" },
        { value: "expatrio", label: "expatrio" },
        { value: "fintiba", label: "fintiba" },
    ];

    const [allConsents, setAllConsents] = useState([]);

    const getAllERPConsents = async () => {
        try {
            const query = {
                "filters": {},
                "limit": entriesLimit,
                "skip": skipEntries
            }

            const getERPConsent = await axios.post(`${serverURL}/consentMap/getAllConsentsWithFilter`, query);

            if (getERPConsent.status === 200) {
                const data = await getERPConsent.data;
                setAllConsents(data.consents)
                setTotalEntriesCount(data.total)
                // console.log(data);
            } else {
                console.log(getERPConsent.data);
            }
        } catch (error) {
            console.error("Error fetching ERP consents:", error);
        }
    }


    const getAllInSync = async () => {
        const getERPConsent = await axios.post(`${serverURL}/consentMap/getERPConsent`)
        if (getERPConsent.status === 200) {
            const data = await getERPConsent.data;
            for (let i = 0; i < data.length; i++) {
                const consent = data[i];
                const newConsent = {
                    callingStatus: {},
                    followUpDate: "",
                    serviceType: {},
                    serviceProvider: {},
                    serviceRemarks: {},
                    consentId: "",
                    stdcode: consent.STDCODE,
                    stdid: consent.STDID,
                    name: consent.STDNAME,
                    email: consent.EMAIL,
                    phone: consent.PHONE,
                    consentType: "",
                    consentAnswer: "",
                    application: consent.APPLICATION,
                    ba_COMPANY: consent.BA_COMPANY,
                    ba_STATUS: consent.BA_STATUS,
                    intakeCode: consent.INTAKECODE,
                    status: consent.STATUS,
                    stdloancode: consent.STDLOANCODE,
                    stdname: consent.STDNAME,
                    ststatus: consent.STSTATUS,
                };

                const saveConsent = await axios.post(`${serverURL}/consentMap/addConsent`, newConsent);
                if (saveConsent.status === 200) {
                    console.log(saveConsent.data);
                } else {
                    console.log(saveConsent.data)
                }
            }

        } else {
            console.log(getERPConsent.data);
        }
    }

    const addFilters = async (naamkaran, value) => {
        let finalSearcher = {}

        if (value.length > 0) {
            if (!searchFilters.includes(naamkaran)) {
                setSearchFilters([...searchFilters, naamkaran]);
                // console.log("Searching with:" + value)

                let top = [...searchFilters, naamkaran].map((data, key) => {
                    const getTheField = document.getElementById(`filter_${data}`)
                    return finalSearcher[`${data}`] = getTheField.value
                })

                // console.log(finalSearcher)
            } else {
                let top = [...searchFilters, naamkaran].map((data, key) => {
                    const getTheField = document.getElementById(`filter_${data}`)
                    return finalSearcher[`${data}`] = getTheField.value
                })

                // console.log(finalSearcher)
            }
        } else {
            if (searchFilters.includes(naamkaran)) {
                setSearchFilters(searchFilters.filter((filter) => { return filter !== naamkaran }))

                searchFilters.filter((filter) => { return filter !== naamkaran }).map((data, key) => {
                    const getTheField = document.getElementById(`filter_${data}`)
                    return finalSearcher[`${data}`] = getTheField.value
                })

                // console.log(finalSearcher)
            } else {
                searchFilters.filter((filter) => { return filter !== naamkaran }).map((data, key) => {
                    const getTheField = document.getElementById(`filter_${data}`)
                    return finalSearcher[`${data}`] = getTheField.value
                })

                // console.log(finalSearcher)
            }
        }

        let FinalFilterFormat = {};

        Object.keys(finalSearcher).map((done, key) => {
            return FinalFilterFormat[`${done}`] = { '$regex': `${finalSearcher[done].trim()}`, '$options': "i" }
        })

        console.log(FinalFilterFormat)

        // [
        //     { "submittedData": { "$elemMatch": { 'Employee Code': { '$regex': 'SS0001' } } } },
        //     { "submittedData": { "$elemMatch": { 'Employee Name': { '$regex': 'Sachin' } } } }
        // ]
        const query = {
            "filters": FinalFilterFormat,
            "limit": entriesLimit,
            "skip": skipEntries
        }

        const getERPConsent = await axios.post(`${serverURL}/consentMap/getAllConsentsWithFilter`, query);

        if (getERPConsent.status === 200) {
            const data = await getERPConsent.data;
            setAllConsents(data.consents)
            setTotalEntriesCount(data.total)
            // console.log(data);
        } else {
            console.log(getERPConsent.data);
        }
    }


    const resetFilters = async (state) => {

        if (state) {
            const allFiltersInput = document.getElementsByClassName("filtersField")
            for (let i = 0; i < allFiltersInput.length; i++) {
                allFiltersInput[i].value = ""
            }

            const allFiltersFrame = document.getElementsByClassName("searchFilters")
            for (let i = 0; i < allFiltersFrame.length; i++) {
                allFiltersFrame[i].style.opacity = "0"
                allFiltersFrame[i].style.transitionDelay = `${(12 * 0.1) - (0.1 * i)}s`
            }

            setTimeout(async () => {

                let FinalFilterFormat = {};

                const query = {
                    "filters": FinalFilterFormat,
                    "limit": entriesLimit,
                    "skip": skipEntries
                }

                const getERPConsent = await axios.post(`${serverURL}/consentMap/getAllConsentsWithFilter`, query);

                if (getERPConsent.status === 200) {
                    const data = await getERPConsent.data;
                    setAllConsents(data.consents)
                    setTotalEntriesCount(data.total)
                    // console.log(data);
                } else {
                    console.log(getERPConsent.data);
                }

                setFilterState(!state)
            }, (allFiltersInput.length * 0.1) * 1000)
        } else {
            const allFiltersInput = document.getElementsByClassName("filtersField")
            for (let i = 0; i < allFiltersInput.length; i++) {
                allFiltersInput[i].value = ""
            }

            const allFiltersFrame = document.getElementsByClassName("searchFilters")
            for (let i = 0; i < allFiltersFrame.length; i++) {
                allFiltersFrame[i].style.opacity = "1"
                allFiltersFrame[i].style.transitionDelay = `${0.1 * i}s`
            }

            setTimeout(() => {
                // getAllForms()
                setFilterState(!state)
            }, (allFiltersInput.length * 0.1) * 1000)
        }
    }


    const saveConsentUpdate = async (e) => {
        e.preventDefault()
        console.log(selectedConsent)
    }

    const updateFollowUp = async (date, id) => {
        console.log(date, id)

        const updateNow = await axios.post(serverURL + "/consentMap/updateFollowUp", { "date": date, "id": id })
        if (updateNow.status === 200) {
            console.log(updateNow.data)
        } else {
            console.log(updateNow.data)
        }
    }
    const setCallingStatus = async (stats, id) => {
        console.log(stats, id)

        const updateNow = await axios.post(serverURL + "/consentMap/updateCallingStatus", { "status": stats, "id": id })
        if (updateNow.status === 200) {
            console.log(updateNow.data)
        } else {
            console.log(updateNow.data)
        }
    }


    const getConsentsList = async (consent) => {
        setSelectedConsent(consent);
        setShowTableFormOffered(true);
    }
    const getConsentsOptedList = async (consent) => {
        setSelectedConsent(consent);
        setShowTableFormOpted(true);
    }

    useEffect(() => {
        getAllERPConsents();
        // getAllInSync()
    }, []);

    useEffect(() => {
        getAllERPConsents()
    }, [entriesLimit, skipEntries]);
    return (
        <>
            <div className="transback h-100 d-flex flex-column p-3">
                <button className='btn text-secondary rounded-pill px-3 py-1 d-flex d-lg-none d-xl-none d-xxl-none align-items-center gap-2' onClick={() => { setShowSideOverlay(true) }}>
                    <MenuIcon />
                </button>
                <div className="headerUserDetails py-1 border-0 d-flex justify-content-between">
                    <span>Student Consent</span>
                    <div className='d-flex gap-2 align-items-center justify-content-center text-dark px-2' style={{ cursor: "pointer" }} title={"Name: " + user.name + "\nEmail: " + user.email}>
                        <i className='fa fa-user'></i>
                        <span>{user.name}</span>
                    </div>
                </div>
                <div className='mt-3 d-flex flex-column gap-2 align-items-start w-100 h-100 overflow-auto'>
                    <table className='table table-yesgermany table-hover m-0'>

                        <thead className='sticky-top'>
                            <tr valign="middle" align="center">
                                <th className='p-1 m-0' style={{ background: "none" }}>
                                    <button type='reset' className='rounded-circle w-100 border-0' style={{ aspectRatio: "1/1", maxWidth: "min-content" }} onClick={() => { resetFilters(filterState) }}>
                                        {
                                            filterState ?
                                                <ClearIcon style={{ fontSize: "1rem" }} />
                                                :
                                                <FilterListIcon style={{ fontSize: "1rem" }} />
                                        }
                                    </button>
                                </th>
                                {
                                    [
                                        "callingStatus",
                                        "followUpDate",
                                        "Service Offered",
                                        "Service Opted",
                                        "stdid",
                                        "name",
                                        "email",
                                        "phone",
                                        "application",
                                        "ba_COMPANY",
                                        "ba_STATUS",
                                        "intakeCode",
                                        "status",
                                        "stdloancode",
                                        "ststatus",
                                        "updatedAt",
                                    ].map((namesOfColumn, key) => {
                                        return (
                                            <th key={key} className='p-1 m-0' style={{ background: "none" }}>
                                                <div className="d-flex align-items-center searchFilters gap-2 rounded" title={`Search by ${namesOfColumn}`} style={{ transitionDelay: `${0.1 * key}s` }}>
                                                    <span>
                                                        <i className='fa fa-search'></i>
                                                    </span>
                                                    <input type="search" placeholder={namesOfColumn} className='p-0 noExist text-center w-100 filtersField' id={`filter_${namesOfColumn}`} onInput={(e) => { addFilters(namesOfColumn, e.target.value) }} />
                                                </div>
                                            </th>
                                        )
                                    })
                                }
                            </tr>
                            <tr>
                                <th colSpan={16} className='py-0' style={{ background: "none" }} ></th>
                            </tr>
                        </thead>
                        <thead>
                            <tr>
                                <th className='text-center text-nowrap' style={{ minWidth: "80px", width: "80px" }}>#{allConsents?.length}</th>
                                <th className='text-center text-nowrap' style={{ minWidth: "200px", width: "200px" }}>Calling Status</th>
                                <th className='text-center text-nowrap' style={{ minWidth: "350px", width: "350px" }}>Follow UpDate</th>
                                <th className='text-center text-nowrap' style={{ minWidth: "400px", width: "400px" }}>Service Offered</th>
                                <th className='text-center text-nowrap' style={{ minWidth: "400px", width: "400px" }}>Service Opted</th>
                                <th className='text-center text-nowrap' style={{ minWidth: "250px", width: "250px" }}>Std Id</th>
                                <th className='text-center text-nowrap' style={{ minWidth: "250px", width: "250px" }}>name</th>
                                <th className='text-center text-nowrap' style={{ minWidth: "300px", width: "300px" }}>email</th>
                                <th className='text-center text-nowrap' style={{ minWidth: "200px", width: "200px" }}>phone</th>
                                <th className='text-center text-nowrap' style={{ minWidth: "100px", width: "100px" }}>application</th>
                                <th className='text-center text-nowrap' style={{ minWidth: "200px", width: "200px" }}>ba_COMPANY</th>
                                <th className='text-center text-nowrap' style={{ minWidth: "300px", width: "300px" }}>ba_STATUS</th>
                                <th className='text-center text-nowrap' style={{ minWidth: "200px", width: "200px" }}>intakeCode</th>
                                <th className='text-center text-nowrap' style={{ minWidth: "300px", width: "300px" }}>status</th>
                                <th className='text-center text-nowrap' style={{ minWidth: "200px", width: "200px" }}>stdloancode</th>
                                <th className='text-center text-nowrap' style={{ minWidth: "100px", width: "100px" }}>ststatus</th>
                                <th className='text-center text-nowrap' style={{ minWidth: "200px", width: "200px" }}>updatedAt</th>
                            </tr>
                        </thead>
                        <tbody>
                            {

                                allConsents.length > 0 ? allConsents.map((consent, index) => (
                                    <tr key={index}>
                                        <td className='text-center'>{index + 1}</td>
                                        <td className='text-center'>
                                            <Select
                                                className="customSelector text-nowrap"
                                                defaultValue={consent.callingStatus}
                                                options={[
                                                    { value: 'Pending', label: 'Pending' },
                                                    { value: 'Connected', label: 'Connected' },
                                                    { value: 'Switched Off', label: 'Switched Off' },
                                                    { value: 'Not Answered', label: 'Not Answered' },
                                                    { value: 'Asked to Call Back', label: 'Asked to Call Back' },
                                                    { value: 'Not Interested', label: 'Not Interested' },
                                                ]}
                                                onChange={(e) => { setCallingStatus(e, consent._id) }}
                                            />
                                        </td>
                                        <td className='text-center'>
                                            <input type="datetime-local" className='form-control' defaultValue={consent.followUpDate} onChange={(e) => { updateFollowUp(e.target.value, consent._id) }} />
                                        </td>
                                        <td className='text-center' onClick={() => { getConsentsList(consent, "") }}>
                                            <button className='btn p-0 m-0 btn-lg rounded-pill'>
                                                <i className='fa fa-edit'></i>
                                            </button>
                                        </td>
                                        <td className='text-center' onClick={() => { getConsentsOptedList(consent); }}>
                                            <button className='btn p-0 m-0 btn-lg rounded-pill'>
                                                <i className='fa fa-edit'></i>
                                            </button>
                                        </td>
                                        <td className='text-center text-nowrap'>{consent.stdid}</td>
                                        <td className='text-center text-nowrap'>{consent.name}</td>
                                        <td className='text-center text-nowrap'>{consent.email}</td>
                                        <td className='text-center text-nowrap'>{consent.phone}</td>
                                        <td className='text-center text-nowrap'>{consent.application}</td>
                                        <td className='text-center text-nowrap'>{consent.ba_COMPANY}</td>
                                        <td className='text-center text-nowrap'>{consent.ba_STATUS}</td>
                                        <td className='text-center text-nowrap'>{consent.intakeCode}</td>
                                        <td className='text-center text-nowrap'>{consent.status}</td>
                                        <td className='text-center text-nowrap'>{consent.stdloancode}</td>
                                        <td className='text-center text-nowrap'>{consent.ststatus}</td>
                                        <td className='text-center text-nowrap'>{dayjs(consent.updatedAt).format("D MMM YYYY h:mma")}</td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="100%" className='text-center'>No consents found</td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>

                <div className='w-100 mt-2 customBackgroundFilter rounded'>
                    <ConfigProvider
                        theme={{
                            components: {
                                Pagination: {
                                    itemActiveBg: "#faf089",
                                    itemActiveBgDisabled: "yellow",
                                    // itemActiveColorDisabled: "",
                                    // itemBg: "",
                                    // itemInputBg: "",
                                    // itemLinkBg: "",

                                },
                            },
                            token: {
                                // colorBgContainer: "",
                                // colorBgContainerDisabled: "",
                                // colorBgTextActive: "",
                                colorBgTextHover: "rgba(255, 246, 164, 0.73)",
                                // colorBorder: "red",
                                // colorPrimary: "",
                                // colorPrimaryBorder: "#faf089",
                                // colorPrimaryHover: "",
                                // colorText: "",
                                // colorTextDisabled: "",
                                // colorTextPlaceholder: "",
                                // borderRadius: "",
                                // borderRadiusLG: "",
                                // borderRadiusSM: "",
                                // controlHeight: "",
                                // controlOutline: "",
                                // controlOutlineWidth: "",
                                // fontFamily: "",
                                // fontSize: "",
                                // lineHeight: "",
                                margin: 0,
                                // motionDurationMid: "",
                                // paddingXXS: ""
                            }
                        }}
                    >
                        <Pagination defaultCurrent={2} current={currentPageNumber} defaultPageSize={entriesLimit} showSizeChanger={true} showQuickJumper={true} simple={false} disabled={false} total={totalEntriesCount} onChange={(e) => { setCurrentPageNumber(e); setSkipEntries((e - 1) * entriesLimit) }} onShowSizeChange={(page, pageSize) => { setEntriesLimit(pageSize) }} />
                    </ConfigProvider>
                </div>
            </div>

            <Modal
                show={showTableFormOffered}
                centered
                size='lg'
                backdrop="static"
                onHide={() => { setShowTableFormOffered(false); }}>
                <form onSubmit={(e) => { saveConsentUpdate(e) }}>
                    <Modal.Header closeButton closeVariant='black'>
                        <Modal.Title style={{ fontSize: "1.3rem" }}>Consent for {selectedConsent?.stdname} ({selectedConsent?.stdid})</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='p-0 m-0'>
                        <table className='table table-bordered table-yesgermany m-0 table-hover'>
                            <thead>
                                <tr valign="middle" align="middle">
                                    <th className='text-nowrap'>Consent</th>
                                    <th className='text-nowrap'>Service</th>
                                    <th className='text-nowrap'>Provider</th>
                                    <th className='text-nowrap' width="100%">Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr valign="middle" align="middle">
                                    <td className='text-nowrap'>
                                        <input type="checkbox" disabled style={{ height: "20px", width: "20px" }} />
                                    </td>
                                    <td className='text-nowrap'>Forex</td>
                                    <td className='text-nowrap'>Easy Transfer</td>
                                    <td className='text-nowrap'><textarea className='form-control' placeholder="Your Message" rows={1} /></td>
                                </tr>
                                <tr valign="middle" align="middle">
                                    <td className='text-nowrap'>
                                        <input type="checkbox" disabled style={{ height: "20px", width: "20px" }} />
                                    </td>
                                    <td className='text-nowrap'>Forex</td>
                                    <td className='text-nowrap'>Indel Remit</td>
                                    <td className='text-nowrap'><textarea className='form-control' placeholder="Your Message" rows={1} /></td>
                                </tr>
                                <tr valign="middle" align="middle">
                                    <td className='text-nowrap'>
                                        <input type="checkbox" disabled style={{ height: "20px", width: "20px" }} />
                                    </td>
                                    <td className='text-nowrap'>Forex</td>
                                    <td className='text-nowrap'>RemitX</td>
                                    <td className='text-nowrap'><textarea className='form-control' placeholder="Your Message" rows={1} /></td>
                                </tr>
                                <tr valign="middle" align="middle">
                                    <td className='text-nowrap'>
                                        <input type="checkbox" disabled style={{ height: "20px", width: "20px" }} />
                                    </td>
                                    <td className='text-nowrap'>Forex</td>
                                    <td className='text-nowrap'>Ebix Cash</td>
                                    <td className='text-nowrap'><textarea className='form-control' placeholder="Your Message" rows={1} /></td>
                                </tr>
                                <tr valign="middle" align="middle">
                                    <td className='text-nowrap'>
                                        <input type="checkbox" disabled style={{ height: "20px", width: "20px" }} />
                                    </td>
                                    <td className='text-nowrap'>Forex</td>
                                    <td className='text-nowrap'>MoneyHop</td>
                                    <td className='text-nowrap'><textarea className='form-control' placeholder="Your Message" rows={1} /></td>
                                </tr>

                                <tr valign="middle" align="middle">
                                    <td className='text-nowrap'>
                                        <input type="checkbox" disabled style={{ height: "20px", width: "20px" }} />
                                    </td>
                                    <td className='text-nowrap'>Study Loan</td>
                                    <td className='text-nowrap'>Gyan Dhan</td>
                                    <td className='text-nowrap'><textarea className='form-control' placeholder="Your Message" rows={1} /></td>
                                </tr>
                                <tr valign="middle" align="middle">
                                    <td className='text-nowrap'>
                                        <input type="checkbox" disabled style={{ height: "20px", width: "20px" }} />
                                    </td>
                                    <td className='text-nowrap'>Study Loan</td>
                                    <td className='text-nowrap'>Credila</td>
                                    <td className='text-nowrap'><textarea className='form-control' placeholder="Your Message" rows={1} /></td>
                                </tr>
                                <tr valign="middle" align="middle">
                                    <td className='text-nowrap'>
                                        <input type="checkbox" disabled style={{ height: "20px", width: "20px" }} />
                                    </td>
                                    <td className='text-nowrap'>Study Loan</td>
                                    <td className='text-nowrap'>Tata Capital</td>
                                    <td className='text-nowrap'><textarea className='form-control' placeholder="Your Message" rows={1} /></td>
                                </tr>
                                <tr valign="middle" align="middle">
                                    <td className='text-nowrap'>
                                        <input type="checkbox" disabled style={{ height: "20px", width: "20px" }} />
                                    </td>
                                    <td className='text-nowrap'>Study Loan</td>
                                    <td className='text-nowrap'>Plodigy</td>
                                    <td className='text-nowrap'><textarea className='form-control' placeholder="Your Message" rows={1} /></td>
                                </tr>
                                <tr valign="middle" align="middle">
                                    <td className='text-nowrap'>
                                        <input type="checkbox" disabled style={{ height: "20px", width: "20px" }} />
                                    </td>
                                    <td className='text-nowrap'>Study Loan</td>
                                    <td className='text-nowrap'>Avanse</td>
                                    <td className='text-nowrap'><textarea className='form-control' placeholder="Your Message" rows={1} /></td>
                                </tr>

                                <tr valign="middle" align="middle">
                                    <td className='text-nowrap'>
                                        <input type="checkbox" disabled style={{ height: "20px", width: "20px" }} />
                                    </td>
                                    <td className='text-nowrap'>Blocked Account</td>
                                    <td className='text-nowrap'>Fintiba</td>
                                    <td className='text-nowrap'><textarea className='form-control' placeholder="Your Message" rows={1} /></td>
                                </tr>
                                <tr valign="middle" align="middle">
                                    <td className='text-nowrap'>
                                        <input type="checkbox" disabled style={{ height: "20px", width: "20px" }} />
                                    </td>
                                    <td className='text-nowrap'>Blocked Account</td>
                                    <td className='text-nowrap'>Coracle</td>
                                    <td className='text-nowrap'><textarea className='form-control' placeholder="Your Message" rows={1} /></td>
                                </tr>
                                <tr valign="middle" align="middle">
                                    <td className='text-nowrap'>
                                        <input type="checkbox" disabled style={{ height: "20px", width: "20px" }} />
                                    </td>
                                    <td className='text-nowrap'>Blocked Account</td>
                                    <td className='text-nowrap'>Expatrio</td>
                                    <td className='text-nowrap'><textarea className='form-control' placeholder="Your Message" rows={1} /></td>
                                </tr>
                            </tbody>
                        </table>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex align-items-center justify-content-end d-flex gap-3">
                            <button type='button' onClick={(e) => { setShowTableFormOffered(false) }} className='btn btn-sm btn-outline-dark rounded-pill w-100' style={{ maxWidth: "80px" }}>Cancel</button>
                            <button type='submit' className='btn btn-sm btn-success rounded-pill w-100' style={{ maxWidth: "80px" }}>Update</button>
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal
                show={showTableFormOpted}
                centered
                size='lg'
                backdrop="static"
                onHide={() => { setShowTableFormOpted(false); }}>
                <form onSubmit={(e) => { saveConsentUpdate(e) }}>
                    <Modal.Header closeButton closeVariant='black'>
                        <Modal.Title style={{ fontSize: "1.3rem" }}>Consent for {selectedConsent?.stdname} ({selectedConsent?.stdid})</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='p-0 m-0'>
                        <table className='table table-bordered table-yesgermany m-0 table-hover'>
                            <thead>
                                <tr valign="middle" align="middle">
                                    <th className='text-nowrap'>Service</th>
                                    <th className='text-nowrap'>Provider</th>
                                    <th className='text-nowrap' width="100%">Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr valign="middle" align="middle">
                                    <td className='text-nowrap'>Forex</td>
                                    <td className='text-nowrap' style={{ minWidth: "300px" }}>
                                        <Select
                                            className="customSelector text-nowrap w-100"
                                            options={[
                                                { value: 'Easy Transfer', label: 'Easy Transfer' },
                                                { value: 'Indel Remit', label: 'Indel Remit' },
                                                { value: 'RemitX', label: 'RemitX' },
                                                { value: 'Ebix Cash', label: 'Ebix Cash' },
                                                { value: 'MoneyHop', label: 'MoneyHop' },
                                                { value: 'Other', label: 'Other' },
                                            ]}
                                        />
                                    </td>
                                    <td className='text-nowrap'><textarea className='form-control' placeholder="Your Message" rows={1} /></td>
                                </tr>
                                <tr valign="middle" align="middle">
                                    <td className='text-nowrap'>Study Loan</td>
                                    <td className='text-nowrap'>
                                        <Select
                                            className="customSelector text-nowrap w-100"
                                            options={[
                                                { value: 'Gyan Dhan', label: 'Gyan Dhan' },
                                                { value: 'Credila', label: 'Credila' },
                                                { value: 'Tata Capital', label: 'Tata Capital' },
                                                { value: 'Plodigy', label: 'Plodigy' },
                                                { value: 'Avanse', label: 'Avanse' },
                                                { value: 'Other', label: 'Other' },
                                            ]}
                                        />
                                    </td>
                                    <td className='text-nowrap'><textarea className='form-control' placeholder="Your Message" rows={1} /></td>
                                </tr>

                                <tr valign="middle" align="middle">
                                    <td className='text-nowrap'>Blocked Account</td>
                                    <td className='text-nowrap'>
                                        <Select
                                            className="customSelector text-nowrap w-100"
                                            options={[
                                                { value: 'Fintiba', label: 'Fintiba' },
                                                { value: 'Coracle', label: 'Coracle' },
                                                { value: 'Expatrio', label: 'Expatrio' },
                                                { value: 'Other', label: 'Other' },
                                            ]}
                                            onChange={(e) => {
                                                if (e.label === "Other") {

                                                } else {

                                                }
                                            }}
                                        />
                                    </td>
                                    <td className='text-nowrap'><textarea className='form-control' placeholder="Your Message" rows={1} /></td>
                                </tr>
                                <tr valign="middle" align="middle">
                                    <td className='text-nowrap'>Travel Insurance</td>
                                    <td className='text-nowrap'>
                                        <Select
                                            className="customSelector text-nowrap w-100"
                                            options={[
                                                { value: 'Care', label: 'Care' },
                                                { value: 'Other', label: 'Other' },
                                            ]}
                                            onChange={(e) => {
                                                if (e.label === "Other") {

                                                } else {

                                                }
                                            }}
                                        />
                                    </td>
                                    <td className='text-nowrap'><textarea className='form-control' placeholder="Your Message" rows={1} /></td>
                                </tr>
                                <tr valign="middle" align="middle">
                                    <td className='text-nowrap'>Health Insurance</td>
                                    <td className='text-nowrap'>
                                        <Select
                                            className="customSelector text-nowrap w-100"
                                            options={[
                                                { value: 'TK', label: 'TK' },
                                                { value: 'Other', label: 'Other' },
                                            ]}
                                            onChange={(e) => {
                                                if (e.label === "Other") {

                                                } else {

                                                }
                                            }}
                                        />
                                    </td>
                                    <td className='text-nowrap'><textarea className='form-control' placeholder="Your Message" rows={1} /></td>
                                </tr>
                            </tbody>
                        </table>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex align-items-center justify-content-end d-flex gap-3">
                            <button type='button' onClick={(e) => { setShowTableFormOpted(false) }} className='btn btn-sm btn-outline-dark rounded-pill w-100' style={{ maxWidth: "80px" }}>Cancel</button>
                            <button type='submit' className='btn btn-sm btn-success rounded-pill w-100' style={{ maxWidth: "80px" }}>Update</button>
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    )
}

export default Consents